import React, { useState } from 'react';
import 'date-fns';
import { MuiPickersUtilsProvider, DateTimePicker } from '@material-ui/pickers';
import red from "@material-ui/core/colors/red";
import { makeStyles } from "@material-ui/core/styles";
//import { createMuiTheme } from "@material-ui/core";
import { createTheme } from "@material-ui/core";
import { ThemeProvider } from "@material-ui/styles";
import DateFnsUtils from '@date-io/date-fns';
import PropTypes from 'prop-types';
import Label from './Label';



const DateField = ({ withDefault, label, input, meta: { touched, invalid, error }, ...custom }) => {


    const useStyles = makeStyles({
        underline: {
            "&&&:before": {
                borderBottom: "none"
            },
            "&&:after": {
                borderBottom: "none"
            }
        }
    });

    const classes = useStyles(); 
    const defaultMaterialTheme = createTheme({
    //const defaultMaterialTheme = createMuiTheme({
        palette: {
            primary: red,
            secondary: red
        },
        typography: {
            fontSize: 12
        }
    });

    const [selectedDate, setSelectedDate] = useState(new Date());
    const handleDateChange = date => setSelectedDate(date);

    return (
        <>
            <div className="input-group mb-2">
                <Label name={label} />
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <ThemeProvider theme={defaultMaterialTheme}>
                        <DateTimePicker
                            value={selectedDate}
                            onChange={handleDateChange}
                            InputProps={{
                                classes,
                                disableUnderline: true
                            }}
                            className={"form-control"}
                            onError={console.log}
                            disablePast
                            placeholder={label}
                            format={"MM/dd/yyyy hh:mm a"}
                            helperText={null}
                            {...input}
                            {...custom}
                        />
                    </ThemeProvider>
                </MuiPickersUtilsProvider>
            </div>
            {touched && (error &&
                <div className="row" style={{ textAlign: "right" }}>
                    <div className="col-md-12 float-right">
                        <span>
                            <small>{error}</small>
                        </span>
                    </div>
                </div>
            )}
        </>
    );
}

DateField.propTypes = {
    selectedDate: PropTypes.string
}

export default DateField;